/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash-es';
import classNames from 'classnames/bind';
import styles from '../../styles.module.scss';

const cx = classNames.bind(styles);

const SportCompetitionLevels = ({ sportDetails, homepageDefaults }) => {
  const [compIndex, setCompIndex] = useState(null);

  const activeCompetitionLevels = (sportDetails?.competitionLevels || []).filter(x => !x.hidden);
  const competitionLevelDefaults = homepageDefaults?.competitionLevels || {};

  if (_.isEmpty(activeCompetitionLevels)) return <div />;

  return (
    <div className="container mt-5">
      <h1 className={cx('fancyText', 'mb-5')}>Competition Levels</h1>
      <div className={cx('horizontal-timeline')}>
        <div className={cx('input-timeline')}>
          {_.map(activeCompetitionLevels, ({ level, description }, i) => (
            <div
              className={cx('input', compIndex === i && 'selected')}
              key={i}
              role="button"
              tabIndex={0}
              onClick={() => {
                if (compIndex === i) {
                  setCompIndex(null);
                  return;
                }
                setCompIndex(i);
              }}
            >
              <span data-level={level} className={cx('tooltip')}>
                <span
                  className={cx('tooltip-text')}
                  dangerouslySetInnerHTML={{
                    __html: description || competitionLevelDefaults[level],
                  }}
                />
              </span>
            </div>
          ))}
        </div>
        {!_.isNull(compIndex) && (
          <div className={cx('competitionDescription')}>
            {activeCompetitionLevels[compIndex].description ||
              competitionLevelDefaults[activeCompetitionLevels[compIndex].level]}
          </div>
        )}
      </div>
    </div>
  );
};

SportCompetitionLevels.propTypes = {
  sportDetails: PropTypes.shape({
    formats: PropTypes.arrayOf({}),
    stylesOfPlay: PropTypes.arrayOf({}),
    notes: PropTypes.string,
    faq: PropTypes.arrayOf({}),
    competitionLevels: PropTypes.arrayOf({}),
  }).isRequired,
  homepageDefaults: PropTypes.shape({
    competitionLevels: PropTypes.shape({}),
  }).isRequired,
};

export default SportCompetitionLevels;
